
const docUrl= process.env.REACT_APP_DOC_URL;

const toTitleCase = (str) => {
    return str.replace(/\b\w/g, char => char.toUpperCase());
};

function PreviouslyUpdatedDocuments({serial, data}) {

  const istDate = new Date(data.updatedAt);
  const formatedUpdateDate=istDate.toLocaleString("en-IN", {
  timeZone: "Asia/Kolkata",
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
  });

  const formateDate = (date) => {
    const istDate = new Date(date);

    // Convert to IST and format as DD/MM/YYYY
    const formattedDate = istDate.toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
      year: 'numeric',
      month: 'long',    // e.g., "June"
      day: 'numeric',   // e.g., "18"
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true 
    });

    return formattedDate;
  }
  

  return (
    <div className="card updated-doc-card">
      <strong>Submit {serial} - {formatedUpdateDate}</strong>
      <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Description</th>
                  <th>Date</th>
                  <th>Document</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.resubmissions.map((resubmitData,index)=>(
                  <tr key={index}>
                    <td>{index+1}</td>
                    <td>{resubmitData.description}</td>
                    <td>{formateDate(resubmitData.createdAt)}</td>
                    <td>{resubmitData.document?<a href={docUrl+resubmitData.document} target="_blank" className="link-pdf">View PDF</a>:<></>}</td>
                    <td><span className={`status ${resubmitData.status}`}>{toTitleCase(resubmitData.status)}</span></td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={5}>
                    <div className="remark-box">
                      {data?.remark}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
      </div>
    </div>
  )
}

export default PreviouslyUpdatedDocuments